import { useCallback, useSyncExternalStore } from "react";
import { useServiceContext } from "../../contexts/services/hooks/use-services-context";
import type { SdkServices } from "../../contexts/services/types/services";
import type { FeatureFlag } from "../../managers/user";
import { logger, LOGS } from "../../utils";

const readFeatureFlag = (sdk: SdkServices, featureFlag: FeatureFlag) => {
    try {
        return Boolean(sdk.userManager.isFeatureFlagEnabled(featureFlag));
    } catch (error) {
        logger.error(
            LOGS.UserManager,
            `Error checking feature flag ${featureFlag}`,
            error,
        );
        return false;
    }
};

/** `false` tant que les services ne sont pas initialisés, relu à chaque `feature-flags-updated`. */
export function useFeatureFlag(featureFlag: FeatureFlag): boolean {
    const { sdk, isInitialized } = useServiceContext();

    const subscribe = useCallback(
        (onChange: () => void) => {
            if (!sdk) return () => {};
            sdk.sessionEventBus.on("feature-flags-updated", onChange);
            return () =>
                sdk.sessionEventBus.off("feature-flags-updated", onChange);
        },
        [sdk],
    );

    const getSnapshot = () =>
        isInitialized && sdk?.userManager
            ? readFeatureFlag(sdk, featureFlag)
            : false;

    return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
